/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const CreateTaskContainer = styled.div({
  display: 'flex',
});

export const AddIconWrapper = styled.span({
  paddingLeft: token('space.050'),
});

/*
 * 1. Ensures the input takes up full width of sidebar.
 * 2. Ensures the input does not not butt up against the
 * edge of the create task icon while adding a new task
 * (aka while focused).
 */
export const CreateTaskFormContainer = styled.div<{ isFocused: boolean }>`
  width: 100%;
  ${({ isFocused }) =>
    isFocused ? `margin-left: ${token('space.100')}` : null};
`;

export const CreateTaskIcon = styled.div({
  display: 'flex',
  marginTop: token('space.100'),
  alignItems: 'center',
});

export const CreateTaskStatusWrapper = styled.div({
  paddingRight: token('space.075'),
});

export const CreateTaskErrorMessage = styled.div({
  font: token('font.body.UNSAFE_small'),
  color: token('color.text.danger'),
  marginTop: token('space.050'),
  marginLeft: '28px',
});
